import { type } from '../constants/manageNumbersConstant'
import { NumberLocationsReducer } from '../models/manageNumbers.interface'

const initialSubState: NumberLocationsReducer = {
    numberLocationsLoading: false,
    numberLocationsData: [],
    numberLocationsError: false,
    numberLocationsErrorMsg: '',
}

const numberLocationsReducer = (state: NumberLocationsReducer = initialSubState, action: any): NumberLocationsReducer => {

    switch (action.type) {
        case type.NUMBER_LOCATION_LOADING:
            return {
                ...state,
                numberLocationsLoading: true,
                numberLocationsError: false
            }
        case type.NUMBER_LOCATION_SUCCESS:
            return {
                ...state,
                numberLocationsLoading: false,
                numberLocationsError: false,
                numberLocationsData: action.payload.res.data,
            }
        case type.NUMBER_LOCATION_FAILED:
            return {
                ...state,
                numberLocationsLoading: false,
                numberLocationsError: true,
                numberLocationsErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default numberLocationsReducer